<template>
  <v-dialog v-model="editDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Edit Payroll Detail information') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 pa-2>
              <v-layout>
                {{ $t('Staff') }}: &nbsp;&nbsp;
                <strong>{{ payrollDetailInfo.user_full_name }}</strong>
              </v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs6 pa-2>
                <v-text-field
                  v-model.number="payrollDetailInfo.base_salary"
                  @input="
                    calculateNetSalary(
                      payrollDetailInfo.base_salary,
                      payrollDetailInfo.incentive,
                      payrollDetailInfo.cut
                    )
                  "
                  :label="`${$t('Base Salary')} *`"
                  hide-details
                  box
                  name="base_salary"
                  data-vv-name="Base Salary"
                  background-color="white"
                  :error="errors.has('Base Salary')"
                  v-validate="'required|decimal:4|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs6 pa-2>
                <v-text-field
                  v-model.number="payrollDetailInfo.incentive"
                  @input="
                    calculateNetSalary(
                      payrollDetailInfo.base_salary,
                      payrollDetailInfo.incentive,
                      payrollDetailInfo.cut
                    )
                  "
                  :label="$t('Incentive')"
                  hide-details
                  box
                  data-vv-name="Incentive"
                  background-color="white"
                  :error="errors.has('Incentive')"
                  v-validate="'decimal:4|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>

              <v-flex xs6 pa-2>
                <v-text-field
                  v-model.number="payrollDetailInfo.cut"
                  @input="
                    calculateNetSalary(
                      payrollDetailInfo.base_salary,
                      payrollDetailInfo.incentive,
                      payrollDetailInfo.cut
                    )
                  "
                  :label="$t('Cut')"
                  hide-details
                  box
                  background-color="white"
                />
              </v-flex>

              <v-flex xs6 pa-2>
                <v-text-field
                  v-model.number="payrollDetailInfo.net_salary"
                  :label="`${$t('Net Salary')} *`"
                  hide-details
                  box
                  readonly
                  name="net_salary"
                  data-vv-name="Net Salary"
                  background-color="white"
                  :error="errors.has('Net Salary')"
                  v-validate="'required|decimal:4|min_value:0'"
                  data-vv-delay="1000"
                />
              </v-flex>
              <v-flex xs12 pa-2>
                <v-textarea
                  v-model="payrollDetailInfo.note"
                  :label="$t('Note')"
                  name="note"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end>
              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnUpdateLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Update') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'edit-component',

  props: {
    editDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnUpdateLoading: false,
      dateModal: false,
      updateForm: {}
    }
  },

  computed: {
    ...mapGetters({
      payrollDetailInfo: 'payrollDetails/getPayrollDetailInfo'
    })
  },

  watch: {
    editDialog: {
      immediate: false,
      handler() {
        if (this.editDialog) {
          this.addEscKeyListener()
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePayrollDetailInfo: 'payrollDetails/updatePayrollDetailInfo'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the 'ESC' button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.editDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    calculateNetSalary(baseSalary, incentive, cut) {
      let net = baseSalary + incentive - cut
      this.payrollDetailInfo.net_salary = net.toFixed(2)
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnUpdateLoading = true
            let formData = new FormData(event.target)
            formData.append('incentive', this.payrollDetailInfo.incentive)
            formData.append('cut', this.payrollDetailInfo.cut)

            if (this.payrollDetailInfo.incentive < 1) {
              formData.append('incentive', 0)
            }
            if (this.payrollDetailInfo.cut < 1) {
              formData.append('cut', 0)
            }
            let payload = {
              id: this.payrollDetailInfo.payroll_detail_id,
              formData
            }
            this.updatePayrollDetailInfo(payload)
              .then(() => {
                this.btnUpdateLoading = false
                this.$emit('updated')
              })
              .catch(() => {
                this.btnUpdateLoading = false
              })
          }
        })
        .catch(() => {
          this.btnUpdateLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
